export default {
  name: 'microapp_search',
  props: ["show_search_bar"],
  data () {
    return {
      title: "microapp_search",
      keyword: ''
    }
  },
  computed: {
    getSearchBar() {
      if(this.show_search_bar){
        this.$nextTick(()=>{
          this.$refs.search_text.focus();
        })
      }
      return this.$store.getters.getSearchBar;
    }
  },
  methods: {
    close_search() {
      this.$store.commit('setSearchBar', false);
      this.keyword= '';
      this.$emit('close_search', true);
    },
    search_keyword() {
      this.$emit('search_keyword', this.keyword);
      this.$refs.search_text.blur();
    }
  },
  watch: {
    // keyword: function () {
    //   this.search_keyword();
    // }
  }
}